type LayoutClassName = "Sidebar" | "SidebarSpaced" | "Container" | "Content";

export const LayoutClassNames: Record<LayoutClassName, string> = {
  Sidebar: "md:w-[200px]",
  SidebarSpaced: "md:ml-[200px] px-2 md:px-6",
  Container: "flex flex-col md:flex-row my-2 md:my-6",
  Content: "px-2 md:px-6 w-full xl:w-container md:max-w-[calc(100%-200px)]",
};
